import { dcFactory } from 'dc';
import LoqateForm from './js/loqate-form';
import LoqateComponent from './js/loqate.component';

dcFactory.register(LoqateComponent);
export {
    LoqateForm,
    LoqateComponent
};
